module.exports = __WEBPACK_EXTERNAL_MODULE__696f__;